import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonLayout } from "../cta-button-layout";
import { CTAButtonLayoutTitleSubtitleContext } from "./cta-button-layout-title-subtitle.models";

@Component({
    selector: "dodo-cta-button-layout-title-subtitle",
    templateUrl: "./cta-button-layout-title-subtitle.component.html",
    styleUrls: ["./cta-button-layout-title-subtitle.component.scss"],
    standalone: false
})
export class CtaButtonLayoutTitleSubtitleComponent extends CTAButtonLayout
	implements OnInit {
	@Input() title: string;
	@Input() subtitle: string;

	@Input() set context(ctx: CTAButtonLayoutTitleSubtitleContext) {
		if (ctx) {
			this.title = this.title || ctx.title;
			this.subtitle = this.subtitle || ctx.subtitle;
		}
	}

	set layoutContext(ctx: CTAButtonLayoutTitleSubtitleContext) {
		if (ctx) {
			this.title = this.title || ctx.title;
			this.subtitle = this.subtitle || ctx.subtitle;
		}
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
